"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var styles_1 = require("@material-ui/core/styles");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../redux/reducers/password-reset/actions");
var PasswordResetForm_1 = __importDefault(require("./components/PasswordResetForm"));
var PasswordResetSuccess_1 = __importDefault(require("./components/PasswordResetSuccess"));
var PasswordResetForm_2 = __importDefault(require("./components/v2/PasswordResetForm"));
var styles_2 = __importDefault(require("./styles"));
var PasswordResetScreen = function (_a) {
    var identifier = _a.identifier, disableAutofill = _a.disableAutofill, isResetPasswordV2 = _a.isResetPasswordV2;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.passwordReset; }), success = _b.success, init = _b.init;
    var theme = (0, styles_1.useTheme)();
    var styleProps = { isResetPasswordV2: isResetPasswordV2 };
    var classes = (0, styles_2.default)(styleProps);
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        return function () {
            dispatch((0, actions_1.reset)());
        };
    }, []);
    var submitCalled = function (password) {
        dispatch((0, actions_1.passwordResetFinish)(identifier, password));
    };
    return (react_1.default.createElement("div", { className: classes.screen },
        react_1.default.createElement(Box_1.default, { className: classes.container, justifyContent: "center" },
            react_1.default.createElement(Card_1.default, { raised: true, className: classes.card },
                react_1.default.createElement(CardContent_1.default, { className: classes.cardContent },
                    react_1.default.createElement("div", { className: classes.cardContentInner },
                        init &&
                            (!isResetPasswordV2 ? (react_1.default.createElement(PasswordResetForm_1.default, { identifier: identifier, onSubmit: submitCalled, disableAutofill: disableAutofill })) : (react_1.default.createElement(PasswordResetForm_2.default, { onSubmit: submitCalled, disableAutofill: disableAutofill }))),
                        success && react_1.default.createElement(PasswordResetSuccess_1.default, null)))))));
};
exports.default = PasswordResetScreen;
//# sourceMappingURL=index.js.map